export default __webpack_public_path__ + "static/media/targeta.7f37b5b2.png";